<template>
  <div>
    <RefundHeader :img_header="header_image" header="รับคืนสินค้า" link_back="refund/refundwaitforprocess"/>
    <Refund_detail/>
  </div>
</template>

<script>
import RefundHeader from "@/components/admin/sell/refund_product/header_refund/RefundHeader";
import HeaderImage from "@/assets/return_refund.png";
import Refund_detail from "@/components/admin/sell/refund_product/Refund_detail";
export default {
  name: "RefundDetail",
  components: {
    Refund_detail,
    RefundHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
